module.exports = __webpack_public_path__ + "static/img/CROSSHULLER.ff53386b.png";